import { createRef, FC, useState } from 'react';
import { Tooltip } from '@abtasty/design-system';
import { useDebounce } from 'react-use';
import { clampLines } from '@src/application/helpers/lineClamp/clampLines';

export const DivWithTooltipOnClamped: FC<{ className?: string; children: string }> = ({ className, children }) => {
  const ref = createRef<HTMLDivElement>();
  const [{ modified, text }, setState] = useState<{ modified: boolean; text: string }>({
    modified: false,
    text: children,
  });

  useDebounce(
    () => {
      if (ref.current) {
        const { modified, text } = clampLines({
          text: children,
          element: ref.current,
          lines: 1,
          ellipsis: '...',
        });
        setState({ modified, text });
      }
    },
    100,
    [window.innerWidth, children, ref.current]
  );
  return (
    <Tooltip content={modified ? children : undefined} type="small">
      <div className={className} ref={ref}>
        {text}
      </div>
    </Tooltip>
  );
};
